import { useEffect, useState } from "react";
import InputLogin from "../components/Inputs/InputLogin";
import BotaoLogin from "../components/Botoes/BotaoLogin";
import { AuthContext } from "../Contexts/AuthContext";
import { useContext } from "react";
import { LoaderCircle } from "lucide-react";

export default function Login() {
  const { loading, fazerLogin, errorMessage, setErrorMessage } =
    useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);

  const propsInputUserName = {
    type: "text",
    placeholder: "usuario",
    mudar: (e) => setUsername(e.target.value),
  };
  const propsInpuPassword = {
    type: "password",
    placeholder: "Senha",
    mudar: (e) => setPassword(e.target.value),
  };

  const propsBotaoLogin1 = {
    texto: loading ? (
      <div className="flex justify-center items-center gap-1 my-1 text-center">
        <span className="text-center"> Processando</span>{" "}
        <LoaderCircle
          strokeWidth={4}
          size={18}
          className={loading ? "animate-spin text-white" : "animate-none"}
        />
      </div>
    ) : (
      "Entrar"
    ),
    type: "submit",
  };
  const propsBotaoLogin2 = {
    texto: "Entrar",
    type: "submit",
  };

  useEffect(() => {
    if (errorMessage) {
      setShowError(true);
      const timer = setTimeout(() => {
        setShowError(false);
        setTimeout(() => {
          setErrorMessage("");
        }, 500);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage, setErrorMessage, loading]);

  return (
    <div className="w-screen h-screen relative flex justify-center items-center font-questrial">
      {/* Background desfocado */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: "url('../../images/bglogin.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(6px)",
        }}
      ></div>

      <div className="flex gap-2 flex-col">
        {/* Mensagem de erro */}
      {errorMessage && (
        <div
          className={`w-full flex justify-center bg-red-700 text-gray-200 transition-opacity duration-500 ${
            showError ? "opacity-100" : "opacity-0"
          }`}
        >
          <span className="py-3 px-4 text-xl">{errorMessage}</span>
        </div>
      )}

      {/* Container do login */}
      <div className="w-[380px] flex justify-center">
        <div className="border-[2px] w-[70%] md:w-[80%] lg:w-full h-[450px] rounded-[50px] border-white z-10">
          <div className="flex justify-center items-center h-full">
            <div className="flex justify-center flex-col w-[80%]">
              <div className="mx-auto flex justify-center flex-col mt-8">
                <img
                  className="mx-auto mb-2"
                  src="../../images/logo.png"
                  width={160}
                  height={100}
                  alt="Logo"
                />
                <span className="text-lg mx-auto lg:text-[16px] text-gray-300 font-semibold">
                NetPay
                </span>
              </div>
              <div className="m-2">
                <InputLogin {...propsInputUserName} />
              </div>
              <div className="m-2">
                <InputLogin {...propsInpuPassword} />
              </div>
              <div className="flex justify-center mt-1">
                {loading ? (
                  <BotaoLogin
                    clicado={() => {}}
                    {...propsBotaoLogin1}
                  />
                ) : (
                  <BotaoLogin
                    clicado={() => {
                      fazerLogin(username, password);
                    }}
                    {...propsBotaoLogin2}
                  />
                )}
              </div>
              <div className="flex justify-center">
                <span className="text-gray-200 text-[12px]">
                  Esqueceu a senha?{" "}
                  <a className="text-blue-400" href="/">
                    clique aqui
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
